import React from 'react';
import { FormField } from '../../components/FormField';
import { FormRow } from '../../components/FormRow';
import { useClientFormContext } from '../../contexts/ClientFormContext';
import { useAgents } from '../../../../../hooks/useAgents';

export const PropertyPreferences: React.FC = () => {
  const { formData, handleInputChange } = useClientFormContext();
  const { agents, isLoading } = useAgents();

  return (
    <div className="space-y-4">
      <FormField label="Agent en charge">
        <select
          name="agent"
          value={formData.agent}
          onChange={handleInputChange}
          className="w-full"
          disabled={isLoading}
        >
          <option value="">Sélectionner un commercial</option>
          {agents.map(agent => (
            <option key={agent.id} value={agent.id}>
              {agent.name} - {agent.title}
            </option>
          ))}
        </select>
      </FormField>
    </div>
  );
};